import Vue from 'vue';
import { MutationTree } from 'vuex';
import { LivingDonor, LivingDonorIntendedRecipient, LivingDonorsState, LivingDonorRecoveryInfo } from '@/store/livingDonors/types';

export const mutations: MutationTree<LivingDonorsState> = {
  set(state, livingDonor) {
    // Clone LivingDonor data and sanitize the clone
    const sanitizedLivingDonor: LivingDonor = Object.assign({}, livingDonor);

    // Store sanitized clone
    Vue.set(state, 'selectedLivingDonor', sanitizedLivingDonor);
  },
  clearLivingDonor(state) {
    Vue.set(state, 'selectedLivingDonor', undefined);
  },
  setList(state, livingDonors) {
    Vue.set(state, 'livingDonorsList', livingDonors);
  },
  setMeasurements(state, measurements) {
    Vue.set(state.selectedLivingDonor!, 'measurements', measurements);
  },
  selectIntendedRecipient(state: LivingDonorsState, intendedRecipient: LivingDonorIntendedRecipient|null) {
    Vue.set(state, 'selectedIntendedRecipient', intendedRecipient);
  },
  setRecoveryInfo(state: LivingDonorsState, { journeyId, recoveryInfo }): void {
    // Clone LivingDonor data and sanitize the clone
    const sanitizedLivingDonor: LivingDonor = Object.assign({}, state.selectedLivingDonor);
    
    // Now with that data replace the relevant journey with new recovery_info
    sanitizedLivingDonor.living_donor_info!.journeys!.map((journey: any) => {
      if (journey._id.$oid == journeyId) { journey.recovery_info = recoveryInfo; }
    });

    // Store the sanitized and updated clone
    Vue.set(state, 'selectedLivingDonor', sanitizedLivingDonor);
  },
};
